<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Reporte de vendedor del mes
    </h2>
    <MainSellerOfTheMonth />
  </div>
</template>

<script>
import MainSellerOfTheMonth from "@/components/Reports/SellerOfTheMonth/MainSellerOfTheMonth.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "SellerOfTheMonth",
  components: {
    MainSellerOfTheMonth,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
